<app-loader [Parent]="this"></app-loader>
@if (Model && !IsBusy) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button routerLink="edit">Edit</form-edit-button>
    </app-pageheader>
    <div class="columns is-centered">
      <div class="column is-8">
        <article class="panel">
          <p class="panel-heading">
            Customer Group Information
          </p>
          <div class="panel-block">
            <div class="field-body" style="width: 100%;">
              <app-field Label="Name">
                <div class="control">
                  <input class="input is-static" type="text" [value]="Model.Name" readonly>
                </div>
              </app-field>
            </div>
          </div>
          @if (Model.Description) {
            <div class="panel-block">
              <div class="field-body" style="width: 100%;">
                <div class="field">
                  <app-field Label="Description">
                    <div class="control">
                      <textarea class="textarea is-static" [value]="Model.Description" readonly rows="3"></textarea>
                    </div>
                  </app-field>
                </div>
              </div>
            </div>
          }
          <div class="panel-block">
            <div class="field-body" style="width: 100%;">
              <app-field Label="External Id">
                <div class="control">
                  <input class="input is-static" type="text" [value]="Model.ExternalId" readonly>
                </div>
              </app-field>
            </div>
          </div>
        </article>
        <article class="panel">
          <p class="panel-heading">
            Capacity Configuration
          </p>
          <div class="panel-block">
            <div class="columns" style="width: 100%;">
              <div class="column">
                <app-field Label="Total Spaces">
                  <div class="control">
                    <input class="input is-static" type="number" [value]="Model.TotalSpaces" readonly>
                  </div>
                </app-field>
                <app-field Label="Reserved Spaces">
                  <div class="control">
                    <input class="input is-static" type="number" [value]="Model.ReservedSpaces" readonly>
                  </div>
                </app-field>
                <app-field Label="Available Spaces">
                  <div class="control">
                    <input class="input is-static" type="number" [value]="Model.AvailableSpaces" readonly>
                  </div>
                </app-field>
                <app-field Label="Current Count">
                  <div class="field has-addons">
                    <div class="control">
                      <input class="input is-static" type="number" [value]="Model.OccupiedSpaces" readonly>
                    </div>
                    <div class="control">
                      <button type="button" class="button is-link is-small" (click)="SetOccupancy()">
                        Update Counts
                      </button>
                    </div>
                  </div>
                </app-field>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
}